export const CAMERA_SIZE = { width: 1080, height: 720 };
